import { createAction, props } from '@ngrx/store';
import {
  UserPlansSummaryFilters,
  UserPlansSummaryModel,
} from '@domain/models/user.model';
import { PaginatedData } from '@base/wrappers/paginated-data';

export class UsersPlansSummaryActions {
  static readonly loadUsers = createAction(
    '[User] Load Users Plans Summary',
    props<{force?: boolean}>()
  );

  static readonly loadUsersSuccess = createAction(
    '[User] Load Users Plans Summary Success',
    props<{
      pagination: PaginatedData<UserPlansSummaryModel>;
    }>()
  );

  static readonly loadUsersFailure = createAction(
    '[User] Load Users Plans Summary Failure',
    props<{ error: any }>()
  );

  static readonly clearUsers = createAction(
    '[User] Clear Users Plans Summary List'
  );

  static readonly setFiltersAndPaginatedData = createAction(
    '[User] Set filters',
    props<{
      filters?: Partial<UserPlansSummaryFilters>
      paginatedData?: Partial<PaginatedData<any>>
    }>()
  )

  static readonly setSelectUser = createAction(
    '[User] Select user',
    props<{
      id: string, isSelected: boolean
    }>()
  )
}
